import axios from 'axios';
import { getAccessToken, logout } from './oktaUtilities.js';
import { store } from '../index.js';
import { logoutAYS } from './appUtilities.js';

const axiosInstance = axios.create();

const ccUser = () => !store?.getState().app?.isAnonymous && store?.getState().user?.userInfo !== null;
const aysUser = () => store?.getState().user?.agentInfo !== null;

axiosInstance.interceptors.request.use(async (config) => {
    if (ccUser()) {
        const accessToken = await getAccessToken();
        if (accessToken) {
            if (config.method !== "OPTIONS") {
                config.headers.authorization = `Bearer ${accessToken}`;
            }
        }
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

axiosInstance.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (error.response && error.response.status === 401) {
        if (ccUser()) {
          logout();  
        } else if (aysUser()) {
            logoutAYS();
        }
        //ignore anonymous  
    }
    return Promise.reject(error);
});

export default axiosInstance;